import { format } from "date-fns-tz"

const arrStatusPayment = [{ text: "Использовано", value: true, color: "green darken-2 white--text" },
    { text: "Неиспользовано", value: false, color: "grey darken-1 white--text" }]
export class PaymentModel {
    constructor (data) {
        this.amount = data.amount
        this.article = data.article
        this.operation = data.operation
        this.paymentOption = data.paymentOption
        this.ruleId = data.ruleId
        this.servicePointId = data.servicePointId
        this.userId = data.userId
        this.used = data ? (data.used ? arrStatusPayment[0] : arrStatusPayment[1]) : arrStatusPayment[1]
        this.paymentId = data.paymentId
        this.updateDate = this._updateDate(data.updateDate)
    }

    toCsv (delimiter) {
        const delim = delimiter || ';'
        return this.article + delim +
            this.amount + delim +
            this.servicePointId + delim +
            this.userId + delim +
            this.ruleId + delim +
            this.used.text + delim +
            this.updateDate + delim + '\n'
    }

    _updateDate (updateDate) {
        const date = new Date(updateDate)
        return format(date, "dd.MM.yyyy HH:mm:ss")
    }
}

export const PaymentTitlesModel = [
    {
        text: "Код товара",
        value: "article",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Сумма",
        value: "amount",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Точка обслуживания",
        value: "servicePointId",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Участник",
        value: "userId",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Правило",
        value: "ruleId",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Использовано",
        value: "used",
        filterType: "list_boolean",
        filterValues: arrStatusPayment.map((m, index) => { return Object.fromEntries([['text', m.text], ['value', m.value]]) })
    },
    {
        text: "Последняя дата изменения",
        value: "updateDate",
        filterType: "date",
        filterValues: []
    }
]

export const PaymentHeadersModel = PaymentTitlesModel.map(m =>
    Object.fromEntries(
        Object.entries(m)
            .filter(([key]) => ['text', 'value'].includes(key))
    )
)

export let paymentCsv = ""
PaymentTitlesModel.forEach(m => (
    paymentCsv += `${m.text};`
))
paymentCsv = `${paymentCsv}\n`
